import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MovieView from '../views/MovieView.vue'
import CinemaView from '../views/CinemaView.vue'

const routes = [
  {
    path: '/test',
    name: 'home',
    component: HomeView,
    meta: [
      { 
        title: 'Kinoprogramm Karakino' 
      },
      {
        property: 'og:title',
        content: 'Kinoprogramm Karakino',
      },
      {
        property: 'og:type', 
        content: 'website' 
      },
      {
        property: 'og:description',
        content: 'Alle Kino-Neustarts nit Programm.',
      }
    ]
  },
  {
    path: '/test/movie/:id/:pageTitle',
    name: 'movie',
    component: MovieView,
    props: true,
    meta: {
      title: 'Film - Kinoprogramm Karakino'
    }
  },
  {
    path: '/test/cinema/:id/:pageTitle',
    name: 'cinema',
    component: CinemaView,
    props: true,
    meta: {
      title: 'Kino - Kinoprogramm Karakino'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: 'smooth', }
  },
})


router.beforeEach((to, from, next) => {
  const titleFromParams = to.params?.pageTitle
  if (titleFromParams) {
    document.title = `${titleFromParams} - Kinoprogramm Karakino`
  } else {
    document.title = to.meta?.title ?? 'Kinoprogramm Karakino'
  }
  next()
})


export default router
